import create from 'zustand';
import { persist } from 'zustand/middleware';

interface IStore {
  //**是否為手機寬度 */
  isMobile: boolean;
  isPad: boolean;
  checkWindowWidth: (width: number) => void;
}

export const useStore = create(
  persist<IStore>(
    (set) => ({
      isMobile: false,
      isPad: false,
      checkWindowWidth: (width: number) => {
        const mobileWidth = 768;
        const PadWidth = 1200;
        if (width <= PadWidth && width > mobileWidth) {
          set({ isPad: true });
          set({ isMobile: false });
        } else if (width <= mobileWidth) {
          set({ isMobile: true });
          set({ isPad: false });
        } else if (width > PadWidth) {
          set({ isPad: false });
          set({ isMobile: false });
        }
      },
    }),
    {
      name: 'storage',
      getStorage: () => sessionStorage, // 僅在當前分頁有效
    },
  ),
);

interface IModalStore {
  isModalOpen: boolean;
  isOldUser?: boolean;
  activeModal: JSX.Element;
  setActiveModal: (modal: JSX.Element) => void;
  closeModal: () => void;
}

export const useModalStore = create<IModalStore>((set) => ({
  isModalOpen: false,
  activeModal: <></>,
  setActiveModal: (modal: JSX.Element) => {
    set({ isModalOpen: true });
    set({ activeModal: modal });
  },
  closeModal: () => {
    set({ isModalOpen: false });
    set({ activeModal: <></> });
    set({ isOldUser: true })
  },
}));
